import { API_CONFIG } from '../lib/apiConfig';
import { parseCsv } from '../lib/csv';
import { createCsvStatsHook } from '../lib/hookFactories';
import { LucaAlerts, LucaMonthlyPoint } from '../lib/types';

// CSV schema: custom_aoi_id,Date,area
// One row per month. `Date` is an ISO yyyy-mm-dd at the start of the month,
// `area` is hectares of detected tree cover loss within the shed for that month.
const parseLuca = (text: string): LucaAlerts => {
  const rows = parseCsv(text);
  const points: LucaMonthlyPoint[] = rows
    .map(row => {
      const date = row['Date'];
      const areaHa = Number(row['area']);
      if (!date || !Number.isFinite(areaHa)) return null;
      const [yStr, mStr] = date.split('-');
      const year = Number(yStr);
      const month = Number(mStr);
      if (!Number.isFinite(year) || !Number.isFinite(month)) return null;
      return { date, year, month, areaHa };
    })
    .filter((p): p is LucaMonthlyPoint => p !== null)
    .sort((a, b) => a.date.localeCompare(b.date));
  return { points };
};

/**
 * Fetches the LUCA monthly deforestation-alert time series for the supply shed
 * defined by (millCode, driveTime). The S3 key shape is
 * sfi/luca/historical/luca_sfi-{producerSlug}_{driveTime}min_zonal_stats_stacked.csv.
 * Four mill codes are renamed in the producer pipeline; the path builder in
 * `apiConfig.ts` aliases those to the producer's slug before composing the URL.
 */
export const useDeforestationAlerts = createCsvStatsHook({
  path: API_CONFIG.s3.paths.lucaStats,
  parse: parseLuca,
  errorPrefix: 'Failed to load deforestation alerts',
});
